/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { CreateUrl, Url } from 'app/functional/models/url.model';

@Injectable({
  providedIn: 'root'
})
export class UrlService {
  private url = `${environment.rootUrl}url/`;

  constructor(private http: HttpClient) { }

  create(model: CreateUrl): Promise<Url> {
    return this.http.post<Url>(this.url, model).toPromise();
  }

  setPrimary(urlId: number): Promise<void> {
    return this.http.post<void>(`${this.url}/${urlId}/set_primary`, {}).toPromise();
  }

  readByCompany(companyId: number): Promise<Url[]> {
    return this.http.get<Url[]>(this.url, {
      params: {
        company_id: companyId.toString(),
      }
    }).toPromise();
  }

  delete(urlId: number): Promise<void> {
    return this.http.delete<void>(this.url + urlId).toPromise();
  }
}
